// extracted by mini-css-extract-plugin
export default {"error":"Errors_error__Y1xe3","img":"Errors_img__IjIwv","title":"Errors_title__NBy4H","title-second":"Errors_title-second__qfr-y","title-third":"Errors_title-third__qR2ID"};